import React from 'react';

import PropTypes from 'prop-types';
import { FaArrowRight } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import employerImage from '../../Assets/img/employer.webp';
import WithBackground from '../Common/WithBackground';

import './style.css';

const EmployerHero = ({ bg, overlay = 'dark' }) => {
  const { t } = useTranslation();

  const heroContent = (
    <section className={`employer-hero ${bg ? '' : 'bgr'}`}>
      <div className='employer-hero__container'>
        <div className='employer-hero__grid'>
          <div className='employer-hero__content'>
            <h1 className='employer-hero__title' data-aos="fade-up" data-aos-delay="100">
              {t('employerHero.title')}
              <br />{' '}
              <span className='employer-hero__title--accent'>{t('employerHero.titleAccent')}</span>
            </h1>

            <p className='employer-hero__subtitle' data-aos="fade-up" data-aos-delay="200">
              {t('employerHero.subtitle')}
            </p>

            <div className='employer-hero__highlight' data-aos="fade-up" data-aos-delay="300">
              <span className='employer-hero__highlight-text'>
                {t('employerHero.highlight')}
              </span>
            </div>

            <div className='employer-hero__actions' data-aos="fade-up" data-aos-delay="400">
              <a href='#contact' className='btn__cta employer-hero__cta'>
                <FaArrowRight className='btn__cta-icon' />
                {t('common.submitRecruitmentOrder')}
              </a>
            </div>
          </div>

          <div className='employer-hero__media' data-aos="fade-left" data-aos-delay="500">
            <img
              src={employerImage}
              alt={t('employerHero.imageAlt')}
              className='employer-hero__image'
            />
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {heroContent}
    </WithBackground>
  ) : (
    heroContent
  );
};

EmployerHero.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

EmployerHero.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default EmployerHero;